import { useState, useEffect } from "react";
import { isRtl } from "@/lib/i18n";
import { trackVisit } from "@/lib/api";
import ChatWidget from "@/components/ChatWidget";

/**
 * Embed page — designed to be loaded inside an iframe on the host site.
 * Renders ONLY the floating chat widget against a transparent background.
 * The host page should make the iframe transparent and pointer-event aware.
 */
export default function EmbedPage() {
  const [lang, setLang] = useState(() => {
    // Auto-detect from browser
    const browserLang = (navigator.language || "tr").slice(0, 2).toLowerCase();
    if (["tr", "en", "ar", "ru"].includes(browserLang)) return browserLang;
    return "tr";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = isRtl(lang) ? "rtl" : "ltr";
    document.body.style.background = "transparent";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, [lang]);

  useEffect(() => {
    if (!sessionStorage.getItem("visit_tracked")) {
      trackVisit();
      sessionStorage.setItem("visit_tracked", "1");
    }
  }, []);

  return (
    <div style={{ position: "fixed", inset: 0, pointerEvents: "none" }} data-testid="embed-page">
      {/* Children of ChatWidget are positioned fixed; pointer-events auto on them */}
      <style>{`
        [data-testid="chat-orb"], [data-testid="chat-panel"], [data-testid="chat-invite"] {
          pointer-events: auto;
        }
      `}</style>
      <ChatWidget lang={lang} setLang={setLang} initialOpen={true} embed={true} />
    </div>
  );
}
